import styled from "@emotion/styled";
import * as React from "react";

import { DesignToken, SpacingToken, Text } from "@livechat/design-system-react-components";

import { ChangeDirection } from "constants/change-direction";
import { withVar } from "themes/helpers";

export enum ChangeLabelType {
  Negative,
  Neutral,
  Positive,
}

const StyledContainer = styled.div`
  display: inline-flex;
  align-items: center;
  margin: 0 8px;
`;

interface IArrowIconProps {
  direction: ChangeDirection;
  positive?: boolean;
}

function getColor(positive?: boolean): string {
  if (positive === true) {
    return withVar(DesignToken.ActionPositiveDefault);
  }

  if (positive === false) {
    return withVar(DesignToken.ActionNegativeDefault);
  }

  return withVar(DesignToken.ContentBasicPrimary);
}

interface IStyledValueProps {
  positive?: boolean;
}

interface IProps {
  value: number | string;
  labelDifference?: string;
  labelEqual?: string;
  direction: ChangeDirection;
  positive?: boolean;
}

export const ChangeLabel: React.FC<IProps> = props => (
  <StyledContainer>
    {props.direction !== ChangeDirection.NoChange && (
      <>
        <ArrowIcon direction={props.direction} positive={props.positive} />
        <StyledValue positive={props.positive}>{props.value}</StyledValue>
        {props.labelDifference && <StyledLabel>{props.labelDifference}</StyledLabel>}
      </>
    )}
    {props.direction === ChangeDirection.NoChange && <StyledLabel>{props.labelEqual}</StyledLabel>}
  </StyledContainer>
);

const ArrowIcon = styled.div<IArrowIconProps>`
  width: 0;
  height: 0;
  border-style: solid;

  border-top-color: ${({ direction, positive }): string =>
    direction === ChangeDirection.Down ? getColor(positive) : "transparent"};
  border-right-color: transparent;
  border-bottom-color: ${({ direction, positive }): string =>
    direction === ChangeDirection.Up ? getColor(positive) : "transparent"};
  border-left-color: transparent;

  border-width: ${({ direction }): string => (direction === ChangeDirection.Up ? "0 4px 7px 4px" : "7px 4px 0 4px")};
`;

const StyledValue = styled(Text)<IStyledValueProps>`
  color: ${({ positive }): string => getColor(positive)};
  margin-left: var(${SpacingToken.Spacing1});
`;

const StyledLabel = styled(Text)`
  color: ${withVar(DesignToken.ContentBasicSecondary)};
  margin-left: var(${SpacingToken.Spacing1});
`;
